import logoTitan from "../assets/logoTitan.png";
import { BsList } from "react-icons/bs";
import { IoIosLogOut } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { ALERT, BASE_URL } from "../config/constants";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/esm/Button";
import { useState, useEffect, lazy, Suspense } from "react";
import "./navbar-in.css";
import jwtDecode from "jwt-decode";
import axios from "axios";
import ButtonGroup from "react-bootstrap/ButtonGroup";

const LazyModalDocs = lazy(() => import("./navbar-in-modal"));

export default function NavbarIn({ title, app }) {
  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const { userName } = decoded;

  //const isProd = process.env.REACT_APP_ENVIRONMENT === "PROD";
  //const urlPortalUnificado = process.env.REACT_APP_URL_PORTAL_UNIFICADO;

  const navigate = useNavigate();
  //const [forceUpdate, setForceUpdate] = useState(0);
  const [superAdminPermissions, setSuperAdminPermissions] = useState(false);
  const [showModalDocs, setShowModalDocs] = useState(false);

  const handleShowModalDocs = () => {
    setShowModalDocs(true);
  };

  const handleCloseModalDocs = () => {
    setShowModalDocs(false);
  };

  async function logout() {
    try {
      //await axios.post(`${BASE_URL}/logout`, {});
    } catch (error) {
      console.error("Error logout:", error?.response?.data || error.message);
    } finally {
      localStorage.clear();
      //setForceUpdate((prev) => prev + 1);

      ALERT.fire({
        icon: "info",
        text: "¡...Sesión cerrada con éxito...!",
        timer: 2000,
        position: "bottom-left",
      });

      navigate("/");
    }
  }

  //traer los superadministradores
  useEffect(() => {
    const getSuperAdmins = async () => {
      const response = await axios.get(`${BASE_URL}/get-super-admins`, {
        headers: {
          Authorization: token,
        },
      });

      if (response.data.ok) {
        const superAdmins = response.data.superAdmins;
        const superAdmin = superAdmins.find(
          (superAdmin) => superAdmin.userName === userName,
        );
        if (superAdmin) {
          setSuperAdminPermissions(true);
        }
      }
    };
    getSuperAdmins();
  }, [token, userName]);

  return (
    <>
      <Navbar bg="light" variant="light" className="custom-navbar">
        <Container>
          <Navbar.Brand href="/admin">
            <img
              src={logoTitan}
              height={30}
              alt="Logo Titan"
              loading="lazy"
              className="custom-logo"
            />
          </Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link href="/admin">
              <BsList className="me-2" />
              Menú
            </Nav.Link>
          </Nav>
          {title && <Navbar.Text className="custom-title">{title}</Navbar.Text>}
          {superAdminPermissions && app ? (
            <ButtonGroup>
              <Button
                variant="outline-primary"
                onClick={() => handleShowModalDocs()}
              >
                Help
              </Button>
              <Button variant="outline-primary" onClick={logout}>
                Cerrar Sesión <IoIosLogOut className="ms-2" />
              </Button>
            </ButtonGroup>
          ) : (
            <Button variant="outline-primary" onClick={logout}>
              Cerrar Sesión <IoIosLogOut className="ms-2" />
            </Button>
          )}
        </Container>
      </Navbar>
      {app && (
        <Suspense fallback={<div>Loading...</div>}>
          <LazyModalDocs
            show={showModalDocs}
            handleClose={handleCloseModalDocs}
            app={app}
            userName={userName}
          />
        </Suspense>
      )}
    </>
  );
}
